import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { AuthService } from '../../auth/auth.service';
import { CookieService } from 'ngx-cookie-service';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { SweetAlertService } from '../../sweetalert/sweet-alert.service';
import { decryptPledgeData } from 'src/app/shared/crypto-js/crypto-js';
import { resolveHttpErrorMessage } from 'src/app/shared/utils/http-error-message';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

	loading: boolean = false;
	constructor(
		private sweeetalertService: SweetAlertService,
		private authService: AuthService,
		private cookie: CookieService,
		private router: Router
	) { }

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(request)
			.pipe(
				catchError((error: unknown) => {
					this.loading = false;
					const httpError =
						error instanceof HttpErrorResponse
							? error
							: new HttpErrorResponse({
									error,
									status: 0,
									statusText: 'Unknown Error',
								});

					if (httpError.status === 401) {
						this.handleAuthError(httpError);
					} else {
						this.showHttpError(httpError);

						if (httpError.status === 504) {
							this.authService.sessionDestory();
						}
					}

					return throwError(() => httpError);
				})
			)
	}

	private showHttpError(error: HttpErrorResponse): void {
		this.sweeetalertService.sweetAlert('error', resolveHttpErrorMessage(error));
	}

	private handleAuthError(err: HttpErrorResponse): Observable<any> {
		if (err.status === 401 || err.status === 400) {
			if (this.cookie.check('encryptedUserSession')) {
				this.cookie.delete('encryptedUserSession', '/');
			}
			this.router.navigate(['/']);
			this.sweeetalertService.sweetAlert('error', resolveHttpErrorMessage(err));
			return of(err.message);
		}
		return throwError(() => err);
	}

    private handleErrorLog(err: HttpErrorResponse) {

		const encryptedUserSession = localStorage.getItem('encryptedUserSession');

		if (encryptedUserSession) {
			const decryptedStr = decryptPledgeData(encryptedUserSession);
			const decryptedData = JSON.parse(decryptedStr);
			const formData: any = new FormData();
			formData.append('clientId', decryptedData.accountId);
			formData.append('location', window.location.href);
			formData.append('api', err.url);
			formData.append('error', JSON.stringify(err.error));
			formData.append('errorText', JSON.stringify(err));
			formData.append('status_code', err.status);
			this.authService.errorLog(formData).subscribe(() => { })
		}
	}
}
